import { DeepPartial, DeepReadonly } from 'ts-essentials';
import { ICTExtendedGuide, ICTColorDmlA, STDirectionPml } from '@tencent/slide-sdk-model';
import { IGuide } from '@src/slide/domain/ui-model/element-modeles/Interface/guide-model-v3.interface';
import { ORIENT_MAP } from '@src/slide/domain/ui-model/converter/node-property/sdk-ui-enum-map/orient';
import { colorStrToColorDmlA, getEgColorChoiceRgba } from '@src/slide/infrastructure/module/independent/color/transform';
import { invertMap } from '@src/slide/infrastructure/module/independent/object/map-invert';

/**
 * 参考线
 */
export class GuidePropertyConverter {
    /**
     * 参考线 sdk -> ui 属性映射
     * @param sdkData
     */
    public static convertPartialDataFromSdkToUi(sdkData: DeepReadonly<DeepPartial<ICTExtendedGuide[]>>): IGuide[] {
        return sdkData.map(e => ({
            type: 'guides',
            pos: e?.pos || 0,
            orient: ORIENT_MAP.get(e?.orient || STDirectionPml?.vert)!,
            color: getEgColorChoiceRgba(e?.clr?.srgbClr),
        }));
    }

    /**
     * 参考线 ui -> sdk 属性映射
     * @param uiData
     */
    public static convertPartialDataFromUiToSdk(uiData: DeepPartial<IGuide[]>): ICTExtendedGuide[] {
        return uiData.map(e => ({
            pos: e?.pos || 0,
            orient: invertMap(ORIENT_MAP).get(e?.orient),
            clr: colorStrToColorDmlA(e?.color) as unknown as ICTColorDmlA,
        }));
    }
}
